import Vue from "vue";
import Vuex from "vuex";
import { UserService, AuthenticationError } from "./../services/user.service";
import { TokenService } from "../services/storage.service";
//import router from '../router'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    users: [],
    clients: [],
    tasks: [],
    qas: [],
    reports: {
      columns: [],
      reports: [],
    },
    clientSelected: {},
    userSelected: {},
    taskSelected: {
      subcategories: [],
    },
    qaSelected: {
      answers: [
        {
          body: "",
        },
      ],
      categories: [
        {
          category_id: "",
        },
      ],
      subcategories: [
        {
          subcategory_id: "",
        },
      ],
    },
    update: false,
    taskUpdate: false,
    qaUpdate: false,
    filterCategory: "",
    filterSubCategory: "",
    filterBodyQA: "",
    filterBodyAnswer: "",
    filterFavoriteQAs: false,
    perfil: localStorage.getItem("perfil"),

    /*token */
    authenticating: false,
    accessToken: TokenService.getToken(),
    authenticationErrorCode: 0,
    authenticationError: "",
  },
  mutations: {
    // cambios en el storage

    //user
    setUsers(state, users) {
      users.map((uss) => {
        state.users.push(uss);
      });
    },
    addUser(state, user) {
      state.users.push(user);
    },
    updateUser(state, user) {
      state.users.map((uss) => {
        if (uss.user_id === user.user_id) {
          uss.name = user.name;
          uss.last_name = user.last_name;
          uss.email = user.email;
          uss.tel = user.tel;
          uss.password = user.password;
        }
      });
    },
    deleteUser(state, id) {
      console.log(id);
      let users = state.users.filter((uss) => {
        return uss.user_id !== id;
      });
      state.users = users;
    },
    selectUser(state, user) {
      state.userSelected = user;
      state.update = true;
    },
    unSelectUser(state, user) {
      state.userSelected = user;
      state.update = false;
    },

    //client
    setClients(state, clients) {
      const cli_ids = state.clients.map((client) => client.client_id);
      clients.map((client) =>
        !cli_ids.includes(client.client_id) ? state.clients.push(client) : null
      );
    },
    addClient(state, client) {
      state.clients.push(client);
    },
    updateClient(state, client) {
      state.clients.map((cli) => {
        if (cli.client_id === client.client_id) {
          cli.name = client.name;
          cli.lastName = client.lastName;
          cli.email = client.email;
          cli.tel = client.tel;
          cli.password = client.password;
        }
      });
    },
    deleteClient(state, id) {
      //console.log(id)
      let clients = state.clients.filter((cli) => {
        return cli.client_id !== id;
      });
      state.clients = clients;
    },
    selectClient(state, client) {
      state.clientSelected = client;
      state.update = true;
    },
    unSelectClient(state, client) {
      state.clientSelected = client;
      state.update = false;
    },

    //task
    setCategories(state, categories) {
      const cat_ids = state.tasks.map((task) => task.category_id);
      categories.map((ctg) =>
        !cat_ids.includes(ctg.category_id) ? state.tasks.push(ctg) : null
      );
    },
    addTask(state, task) {
      state.tasks.push(task);
    },
    updateTask(state, task) {
      state.tasks.map((tsk) => {
        if (tsk.category_id === task.category_id) {
          console.log("tsk", tsk);
          console.log("task", task);
          tsk = task;
        }
      });
    },
    deleteTask(state, id) {
      let tasks = state.tasks.filter((tsk) => {
        return tsk.category_id !== id;
      });
      state.tasks = tasks;
    },
    selectTask(state, task) {
      state.taskSelected = task;
      state.taskUpdate = true;
    },
    unSelectTask(state, task) {
      state.taskSelected = {
        subcategories: [],
      };
      state.taskUpdate = false;
    },
    //qas
    setQuestionAnswers(state, quests) {
      const qa_ids = state.qas.map((qa) => qa.question_id);
      quests.map((quest) =>
        !qa_ids.includes(quest.question_id) ? state.qas.push(quest) : null
      );
    },
    addQA(state, qa) {
      state.qas.push(qa);
      state.qas.sort((a, b) => a.score - b.score);
    },
    updateQA(state, qa) {
      state.qas.map((quest) => {
        if (quest.question_id === qa.question_id) {
          quest.qbody = qa.qbody;
          quest.body = qa.body;
          quest.favorite = qa.favorite;
          quest.score = qa.score;
          quest.answer_id = qa.answer_id;
          quest.abody = qa.abody;
        }
      });
    },
    deleteQA(state, id) {
      //console.log(id)
      //debugger;
      let qas = state.qas.filter((quest) => {
        return quest.question_id !== id;
      });
      state.qas = qas;
    },
    selectQA(state, qa) {
      state.qaSelected = qa;
      state.qaUpdate = true;
    },
    unSelectQA(state, qa) {
      state.qaSelected = {
        answers: [
          {
            body: "",
          },
        ],
        categories: [
          {
            category_id: "",
          },
        ],
        subcategories: [
          {
            subcategory_id: "",
          },
        ],
      };
      state.qaUpdate = false;
    },
    //reports
    setReports(state, reports) {
      //console.log(quests)
      state.reports = reports;
    },
    //Filters
    setFavoriteFilter(state, filter) {
      state.filterFavoriteQAs = true;
      document.title = filter || "sin filtro";
      state.filterBodyQA = "";
      state.filterBodyAnswer = "";
      state.filterSubCategory = "";
      state.filterCategory = "";
    },
    setCategoryFilter(state, filter) {
      document.title = filter || "sin filtro";
      state.filterBodyQA = "";
      state.filterBodyAnswer = "";
      state.filterFavoriteQAs = false;
      state.filterSubCategory = "";
      state.filterCategory = filter;
    },
    setSubCategoryFilter(state, filter) {
      state.filterSubCategory = filter;
    },
    setFilterBodyAnswer(state, filter) {
      state.filterBodyAnswer = filter.toLowerCase();
    },
    setFilterBodyQA(state, filter) {
      state.filterBodyQA = filter.toLowerCase();
    },
    unSetCategoryFilter(state) {
      state.filterBodyQA = "";
      //state.filterCategory = '';
      state.filterSubCategory = "";
    },
    unSetAllFilters(state) {
      state.filterBodyAnswer = "";
      state.filterBodyQA = "";
      state.filterCategory = "";
      state.filterSubCategory = "";
      state.filterFavoriteQAs = false;
    },
    unSetAllSubFilters(state) {
      state.filterBodyAnswer = "";
      state.filterBodyQA = "";
      state.filterSubCategory = "";
      //state.filterFavoriteQAs = false;
    },
    //perfil
    setPerfil(state, perfil) {
      state.perfil = perfil;
    },

    /** token */
    loginRequest(state) {
      state.authenticating = true;
      state.authenticationError = "";
      state.authenticationErrorCode = 0;
    },

    loginSuccess(state, accessToken) {
      state.accessToken = accessToken;
      state.authenticating = false;
    },

    loginError(state, { errorCode, errorMessage }) {
      state.authenticating = false;
      state.authenticationErrorCode = errorCode;
      state.authenticationError = errorMessage;
    },

    logoutSuccess(state) {
      state.accessToken = "";
    },
  },

  actions: {
    // llama a las mutaciones
    //clients
    setClientsAction(context, clients) {
      context.commit("setClients", clients);
    },
    addClientAction(context, client) {
      context.commit("addClient", client);
    },
    updateClientAction(context, client) {
      context.commit("updateClient", client);
    },
    deleteClientAction(context, id) {
      context.commit("deleteClient", id);
    },
    selectClientAction(context, client) {
      context.commit("selectClient", client);
    },
    unSelectClientAction(context, client) {
      context.commit("unSelectClient", client);
    },
    // users
    setUsersAction(context, users) {
      context.commit("setUsers", users);
    },
    addUserAction(context, user) {
      context.commit("addUser", user);
    },
    updateUserAction(context, user) {
      context.commit("updateUser", user);
    },
    deleteUserAction(context, id) {
      context.commit("deleteUser", id);
    },
    selectUserAction(context, user) {
      context.commit("selectUser", user);
    },
    unSelectUserAction(context, user) {
      context.commit("unSelectUser", user);
    },
    //categories
    setCategoriesAction(context, ctgs) {
      context.commit("setCategories", ctgs);
    },
    addTaskAction(context, task) {
      context.commit("addTask", task);
    },
    updateTaskAction(context, task) {
      context.commit("updateTask", task);
    },
    deleteTaskAction(context, id) {
      context.commit("deleteTask", id);
    },
    selectTaskAction(context, task) {
      context.commit("selectTask", task);
    },
    unSelectTaskAction(context, task) {
      context.commit("unSelectTask", task);
    },
    //qas
    setQAsAction(context, qts) {
      context.commit("setQuestionAnswers", qts);
    },
    addQAAction(context, qa) {
      context.commit("addQA", qa);
    },
    updateQAAction(context, qa) {
      context.commit("updateQA", qa);
    },
    deleteQAAction(context, id) {
      context.commit("deleteQA", id);
    },
    selectQAAction(context, qa) {
      context.commit("selectQA", qa);
    },
    unSelectQAAction(context, qa) {
      context.commit("unSelectQA", qa);
    },
    //report
    setReportsAction(context, reports) {
      context.commit("setReports", reports);
    },
    //filters
    setCategoryFilterAction(context, filter) {
      context.commit("setCategoryFilter", filter);
    },
    setFavoriteFilterAction(context, filter) {
      context.commit("setFavoriteFilter", filter);
    },
    setSubCategoryFilterAction(context, filter) {
      context.commit("setSubCategoryFilter", filter);
    },
    unSetCategoryFilterAction(context) {
      context.commit("unSetCategoryFilter");
    },
    unSetAllFiltersAction(context) {
      context.commit("unSetAllFilters");
    },
    unSetAllSubFiltersAction(context) {
      context.commit("unSetAllSubFilters");
    },
    setFilterBodyAnswerAction(context, filterBodyAnswer) {
      context.commit("setFilterBodyAnswer", filterBodyAnswer);
    },
    setFilterBodyQAAction(context, filterBodyQA) {
      context.commit("setFilterBodyQA", filterBodyQA);
    },
    //perfil
    setPerfilAction(context, perfil) {
      context.commit("setPerfil", perfil);
    },

    /* token */
    async login({ commit }, { username, password }) {
      commit("loginRequest");

      try {
        const { token, perfil } = await UserService.login(username, password);
        commit("loginSuccess", token);
        commit("setPerfil", perfil);

        //debugger;
        // Redirect the user to the page he first tried to visit or to the home view
        //router.push('home');

        return token && perfil ? true : false;
      } catch (e) {
        if (e instanceof AuthenticationError) {
          commit("loginError", {
            errorCode: e.errorCode,
            errorMessage: e.message,
          });
        }

        return false;
      }
    },

    logout({ commit }) {
      UserService.logout();
      commit("logoutSuccess");
      router.push("/login");
    },
  },
  getters: {
    // get data del storage
    //clients
    getClients(state) {
      return state.clients;
    },
    getClientSelected(state) {
      return state.clientSelected;
    },
    getIsUpdate(state) {
      return state.update;
    },
    //users
    getUsers(state) {
      return state.users;
    },
    getUserSelected(state) {
      return state.userSelected;
    },
    /* TODO  hacer get user update y limpiar forms al editar y eliminar */
    //tasks
    getTasks(state) {
      return state.tasks;
    },
    getSubTasks(state) {
      //const categories = state.tasks;
      const subcategories = state.tasks.map((tsk) => tsk.subcategories).flat();
      //console.log('categories',categories);
      //console.log('subcategories',subcategories);
      return subcategories;
    },
    getTaskSelected(state) {
      return state.taskSelected;
    },
    getSubtaskToTaskSelected(state) {
      return state.taskSelected.subcategories.map((sc) => sc.name);
    },
    getIsTaskUpdate(state) {
      return state.taskUpdate;
    },
    //qas
    getQAs(state) {
      return state.qas;
    },
    getQasFiltered(state) {
      let result = state.qas;
      if (state.filterFavoriteQAs) {
        result = result.filter((qa) => {
          return qa.favorite;
        });
        //console.log("lista filtrada abody",result);
      }
      if (state.filterBodyAnswer !== "") {
        result = result.filter((qa) => {
          //console.log("No esta vacio",qa.abody)
          const value = (qa.answers[0].body || "")
            .toLowerCase()
            .search(state.filterBodyAnswer.toString());
          return value !== -1 ? true : false;
        });
        //console.log("lista filtrada abody",result);
      }
      if (state.filterBodyQA) {
        result = result.filter((qa) => {
          //console.log("No esta vacio",qa.abody)
          const value = (qa.body || "")
            .toLowerCase()
            .search(state.filterBodyQA.toString());
          return value !== -1 ? true : false;
        });
      }
      //console.log("lista no filtrada abody",result);
      result = !state.filterCategory
        ? result
        : result.filter((qa) => {
            const qaCategories = qa.categories.map((ctg) => ctg.name);
            return qaCategories.includes(state.filterCategory);
          });

      result = !state.filterSubCategory
        ? result
        : result.filter((qa) => {
            const qaSubCategories = qa.subcategories.map(
              (subCtg) => subCtg.name
            );
            return qaSubCategories.includes(state.filterSubCategory);
          });

      return result;
    },
    getQASelected(state) {
      return state.qaSelected;
    },
    getIsQAUpdate(state) {
      return state.qaUpdate;
    },
    // reports
    getReports(state) {
      return state.reports.reports;
    },
    getReportsColumns(state) {
      return state.reports.columns;
    },
    //categoty
    getFilterCategory(state) {
      return state.filterCategory;
    },
    //perfil
    getPerfil(state) {
      return state.perfil;
    },
    //filters
    getCategoryFilter(state) {
      return state.filterCategory;
    },
    getSubCategoryFilter(state) {
      return state.filterSubCategory;
    },

    /* token */
    loggedIn: (state) => {
      return state.accessToken ? true : false;
    },

    authenticationErrorCode: (state) => {
      return state.authenticationErrorCode;
    },

    authenticationError: (state) => {
      return state.authenticationError;
    },

    authenticating: (state) => {
      return state.authenticating;
    },
  },
  modules: {},
});
